var map = {
	"./alarm-fill.svg": "eZXB",
	"./alarm.svg": "mMjV",
	"./align-bottom.svg": "9FOp",
	"./align-center.svg": "O+qS",
	"./align-end.svg": "gQOB",
	"./align-middle.svg": "313A",
	"./align-start.svg": "iDk7",
	"./align-top.svg": "oO5b",
	"./alt.svg": "6Cgk",
	"./app-indicator.svg": "C7oS",
	"./app.svg": "CGqL",
	"./archive-fill.svg": "TYks",
	"./archive.svg": "cli+",
	"./arrow-90deg-down.svg": "u47N",
	"./arrow-90deg-left.svg": "D5da",
	"./arrow-90deg-right.svg": "YmNy",
	"./arrow-90deg-up.svg": "D94y",
	"./arrow-bar-down.svg": "u/v/",
	"./arrow-bar-left.svg": "7yMd",
	"./arrow-bar-right.svg": "4vdE",
	"./arrow-bar-up.svg": "gMxj",
	"./arrow-clockwise.svg": "/woK",
	"./arrow-counterclockwise.svg": "In5j",
	"./arrow-down-circle-fill.svg": "kB7P",
	"./arrow-down-circle.svg": "mqwo",
	"./arrow-down-left-circle-fill.svg": "Abv0",
	"./arrow-down-left-circle.svg": "HCZb",
	"./arrow-down-left-square-fill.svg": "kk4W",
	"./arrow-down-left-square.svg": "kfgc",
	"./arrow-down-left.svg": "J2e5",
	"./arrow-down-right-circle-fill.svg": "1VHe",
	"./arrow-down-right-circle.svg": "jvpJ",
	"./arrow-down-right-square-fill.svg": "P6St",
	"./arrow-down-right-square.svg": "JIqV",
	"./arrow-down-right.svg": "Go1N",
	"./arrow-down-short.svg": "+ZMg",
	"./arrow-down-square-fill.svg": "smsW",
	"./arrow-down-square.svg": "Oe2B",
	"./arrow-down-up.svg": "w8i9",
	"./arrow-down.svg": "Peom",
	"./arrow-left-circle-fill.svg": "m0WR",
	"./arrow-left-circle.svg": "7RSz",
	"./arrow-left-right.svg": "re69",
	"./arrow-left-short.svg": "G5kO",
	"./arrow-left-square-fill.svg": "65LN",
	"./arrow-left-square.svg": "TBvo",
	"./arrow-left.svg": "INtk",
	"./arrow-repeat.svg": "Saf9",
	"./arrow-return-left.svg": "RYaW",
	"./arrow-return-right.svg": "mDOU",
	"./arrow-right-circle-fill.svg": "54ms",
	"./arrow-right-circle.svg": "MhRJ",
	"./arrow-right-short.svg": "10b5",
	"./arrow-right-square-fill.svg": "i4tS",
	"./arrow-right-square.svg": "eQJ+",
	"./arrow-right.svg": "dxdv",
	"./arrow-up-circle-fill.svg": "S4i1",
	"./arrow-up-circle.svg": "LfOS",
	"./arrow-up-left-circle-fill.svg": "W4kV",
	"./arrow-up-left-circle.svg": "tOfR",
	"./arrow-up-left-square-fill.svg": "j1zl",
	"./arrow-up-left-square.svg": "9IkW",
	"./arrow-up-left.svg": "OFh+",
	"./arrow-up-right-circle-fill.svg": "riaB",
	"./arrow-up-right-circle.svg": "wAwu",
	"./arrow-up-right-square-fill.svg": "ZBaE",
	"./arrow-up-right-square.svg": "eIg/",
	"./arrow-up-right.svg": "2Lqg",
	"./arrow-up-short.svg": "WsNE",
	"./arrow-up-square-fill.svg": "u9sf",
	"./arrow-up-square.svg": "tz5m",
	"./arrow-up.svg": "P3Ow",
	"./arrows-angle-contract.svg": "EdtO",
	"./arrows-angle-expand.svg": "QQSJ",
	"./arrows-collapse.svg": "rFEc",
	"./arrows-expand.svg": "wpES",
	"./arrows-fullscreen.svg": "NoEf",
	"./arrows-move.svg": "v089",
	"./aspect-ratio-fill.svg": "JXd2",
	"./aspect-ratio.svg": "z9OK",
	"./asterisk.svg": "9YoY",
	"./at.svg": "2zQ7",
	"./award-fill.svg": "vdER",
	"./award.svg": "M20G",
	"./back.svg": "RN8c",
	"./backspace-fill.svg": "yEr/",
	"./backspace-reverse-fill.svg": "iBho",
	"./backspace-reverse.svg": "XW8e",
	"./backspace.svg": "9gYm",
	"./badge-4k-fill.svg": "Se0Z",
	"./badge-4k.svg": "XDg1",
	"./badge-8k-fill.svg": "Xqrl",
	"./badge-8k.svg": "ViTG",
	"./badge-ad-fill.svg": "LE5e",
	"./badge-ad.svg": "gckU",
	"./badge-cc-fill.svg": "GA/N",
	"./badge-cc.svg": "0/2n",
	"./badge-hd-fill.svg": "h2tc",
	"./badge-hd.svg": "gbSX",
	"./badge-tm-fill.svg": "7dqs",
	"./badge-tm.svg": "Q9ES",
	"./badge-vo-fill.svg": "dd09",
	"./badge-vo.svg": "bPZT",
	"./bag-check-fill.svg": "AmOs",
	"./bag-check.svg": "wT3X",
	"./bag-dash-fill.svg": "AJ7q",
	"./bag-dash.svg": "2DFO",
	"./bag-fill.svg": "4/j1",
	"./bag-plus-fill.svg": "j07w",
	"./bag-plus.svg": "d9c9",
	"./bag-x-fill.svg": "tNR4",
	"./bag-x.svg": "hyMJ",
	"./bag.svg": "7EYT",
	"./baodan.svg": "5EDD",
	"./bar-chart-fill.svg": "LqtG",
	"./bar-chart-line-fill.svg": "ym+4",
	"./bar-chart-line.svg": "16CQ",
	"./bar-chart-steps.svg": "+f9y",
	"./bar-chart.svg": "Op1Q",
	"./basket-fill.svg": "TayA",
	"./basket.svg": "BUqf",
	"./basket2-fill.svg": "nC6r",
	"./basket2.svg": "X/yg",
	"./basket3-fill.svg": "bKA2",
	"./basket3.svg": "Dpiu",
	"./battery-charging.svg": "wJc5",
	"./battery-full.svg": "OTuz",
	"./battery-half.svg": "fRTQ",
	"./battery.svg": "WLkG",
	"./bell-fill.svg": "+7OB",
	"./bell.svg": "AFe0",
	"./bezier.svg": "9zoH",
	"./bezier2.svg": "QOa8",
	"./bicycle.svg": "41Cq",
	"./binoculars-fill.svg": "t9op",
	"./binoculars.svg": "vMgq",
	"./blockquote-left.svg": "RJT4",
	"./blockquote-right.svg": "5f/y",
	"./book-fill.svg": "v6sM",
	"./book-half.svg": "TDJX",
	"./book.svg": "W9Um",
	"./bookmark-check-fill.svg": "RTbe",
	"./bookmark-check.svg": "XUoy",
	"./bookmark-dash-fill.svg": "Qm+/",
	"./bookmark-dash.svg": "dsZl",
	"./bookmark-fill.svg": "JJae",
	"./bookmark-heart-fill.svg": "E5XY",
	"./bookmark-heart.svg": "+27r",
	"./bookmark-plus-fill.svg": "hFCf",
	"./bookmark-plus.svg": "/8ie",
	"./bookmark-star-fill.svg": "7lXT",
	"./bookmark-star.svg": "pFy/",
	"./bookmark-x-fill.svg": "IIwG",
	"./bookmark-x.svg": "zLFC",
	"./bookmark.svg": "ZLUN",
	"./bookmarks-fill.svg": "qjjX",
	"./bookmarks.svg": "gHzZ",
	"./bookshelf.svg": "Q8kQ",
	"./bootstrap-fill.svg": "f1P1",
	"./bootstrap-icons.svg": "3kw9",
	"./bootstrap-reboot.svg": "v7tj",
	"./bootstrap.svg": "iJnh",
	"./border-style.svg": "MLIY",
	"./border-width.svg": "/Bdy",
	"./bounding-box-circles.svg": "X8Rm",
	"./bounding-box.svg": "12L+",
	"./box-arrow-down-left.svg": "cFCR",
	"./box-arrow-down-right.svg": "VI8d",
	"./box-arrow-down.svg": "3rG3",
	"./box-arrow-in-down-left.svg": "cxCO",
	"./box-arrow-in-down-right.svg": "il/E",
	"./box-arrow-in-down.svg": "+HVI",
	"./box-arrow-in-left.svg": "BbN+",
	"./box-arrow-in-right.svg": "KNWU",
	"./box-arrow-in-up-left.svg": "KItn",
	"./box-arrow-in-up-right.svg": "XUzm",
	"./box-arrow-in-up.svg": "BoL0",
	"./box-arrow-left.svg": "nvxr",
	"./box-arrow-right.svg": "eFAd",
	"./box-arrow-up-left.svg": "8uFB",
	"./box-arrow-up-right.svg": "auDv",
	"./box-arrow-up.svg": "Jv0q",
	"./box-seam.svg": "PX3b",
	"./box.svg": "N5kO",
	"./braces.svg": "x0Df",
	"./bricks.svg": "Z8oV",
	"./briefcase-fill.svg": "Dsnp",
	"./briefcase.svg": "GpO3",
	"./brightness-alt-high-fill.svg": "ANQb",
	"./brightness-alt-high.svg": "kuJB",
	"./brightness-alt-low-fill.svg": "3IJ2",
	"./brightness-alt-low.svg": "kLWG",
	"./brightness-high-fill.svg": "TDsJ",
	"./brightness-high.svg": "1XUI",
	"./brightness-low-fill.svg": "F16H",
	"./brightness-low.svg": "X1ze",
	"./broadcast-pin.svg": "KAw6",
	"./broadcast.svg": "FUee",
	"./brush-fill.svg": "eg1g",
	"./brush.svg": "eGu5",
	"./bucket-fill.svg": "ZSyD",
	"./bucket.svg": "yHA3",
	"./bug-fill.svg": "WuOJ",
	"./bug.svg": "SVqS",
	"./building.svg": "rb/r",
	"./bullseye.svg": "OHm1",
	"./calculator-fill.svg": "Ng9u",
	"./calculator.svg": "6GM2",
	"./calendar-check-fill.svg": "d13h",
	"./calendar-check.svg": "/GeZ",
	"./calendar-date-fill.svg": "fxhP",
	"./calendar-date.svg": "/xA0",
	"./calendar-day-fill.svg": "0S2K",
	"./calendar-day.svg": "m6NR",
	"./calendar-event-fill.svg": "MNZb",
	"./calendar-event.svg": "p8NF",
	"./calendar-fill.svg": "7F8K",
	"./calendar-minus-fill.svg": "OifN",
	"./calendar-minus.svg": "J1rQ",
	"./calendar-month-fill.svg": "CObe",
	"./calendar-month.svg": "gws0",
	"./calendar-plus-fill.svg": "YR8V",
	"./calendar-plus.svg": "FAHM",
	"./calendar-range-fill.svg": "pzEc",
	"./calendar-range.svg": "uwCg",
	"./calendar-week-fill.svg": "VjPP",
	"./calendar-week.svg": "g6lt",
	"./calendar-x-fill.svg": "xx5y",
	"./calendar-x.svg": "MWDc",
	"./calendar.svg": "bc+5",
	"./calendar2-check-fill.svg": "Sj7Q",
	"./calendar2-check.svg": "MdgI",
	"./calendar2-date-fill.svg": "RkqS",
	"./calendar2-date.svg": "Lteu",
	"./calendar2-day-fill.svg": "qQ2I",
	"./calendar2-day.svg": "WmV0",
	"./calendar2-event-fill.svg": "1BfL",
	"./calendar2-event.svg": "B0zv",
	"./calendar2-fill.svg": "iEVR",
	"./calendar2-minus-fill.svg": "DNwi",
	"./calendar2-minus.svg": "5zQL",
	"./calendar2-month-fill.svg": "KI/O",
	"./calendar2-month.svg": "IGcP",
	"./calendar2-plus-fill.svg": "55wL",
	"./calendar2-plus.svg": "HS6c",
	"./calendar2-range-fill.svg": "0pX9",
	"./calendar2-range.svg": "iKdo",
	"./calendar2-week-fill.svg": "u1YF",
	"./calendar2-week.svg": "Qsbg",
	"./calendar2-x-fill.svg": "+BbK",
	"./calendar2-x.svg": "nkw5",
	"./calendar2.svg": "4Kvk",
	"./calendar3-event-fill.svg": "wfkV",
	"./calendar3-event.svg": "LkR6",
	"./calendar3-fill.svg": "ux3d",
	"./calendar3-range-fill.svg": "RM7m",
	"./calendar3-range.svg": "yAZH",
	"./calendar3-week-fill.svg": "oHEA",
	"./calendar3-week.svg": "If2G",
	"./calendar3.svg": "Aav+",
	"./calendar4-event.svg": "SfW8",
	"./calendar4-range.svg": "ViqN",
	"./calendar4-week.svg": "E6DS",
	"./calendar4.svg": "pR/S",
	"./camera-fill.svg": "lmYg",
	"./camera-reels-fill.svg": "AsCD",
	"./camera-reels.svg": "hecF",
	"./camera-video-fill.svg": "sN+g",
	"./camera-video-off-fill.svg": "09UA",
	"./camera-video-off.svg": "zCr8",
	"./camera-video.svg": "bpHr",
	"./camera.svg": "2vhn",
	"./camera2.svg": "GWyg",
	"./capslock-fill.svg": "Xu0u",
	"./capslock.svg": "PgAS",
	"./card-checklist.svg": "H8wI",
	"./card-heading.svg": "kAhh",
	"./card-image.svg": "3UOW",
	"./card-list.svg": "MDXi",
	"./card-text.svg": "esAR",
	"./caret-down-fill.svg": "EowW",
	"./caret-down-square-fill.svg": "OkcP",
	"./caret-down-square.svg": "e6tj",
	"./caret-down.svg": "911u",
	"./caret-left-fill.svg": "8Iux",
	"./caret-left-square-fill.svg": "aJsm",
	"./caret-left-square.svg": "OmrV",
	"./caret-left.svg": "Axjv",
	"./caret-right-fill.svg": "Jo93",
	"./caret-right-square-fill.svg": "b8Ru",
	"./caret-right-square.svg": "V+0A",
	"./caret-right.svg": "PrWE",
	"./caret-up-fill.svg": "Xqf5",
	"./caret-up-square-fill.svg": "xg/2",
	"./caret-up-square.svg": "j+zf",
	"./caret-up.svg": "cOSt",
	"./cart-check-fill.svg": "iMlF",
	"./cart-check.svg": "sXFL",
	"./cart-dash-fill.svg": "SGjV",
	"./cart-dash.svg": "0GTi",
	"./cart-fill.svg": "JiFP",
	"./cart-plus-fill.svg": "AmWR",
	"./cart-plus.svg": "Hgbk",
	"./cart-x-fill.svg": "DvdW",
	"./cart-x.svg": "E+/o",
	"./cart.svg": "FkN6",
	"./cart2.svg": "w04b",
	"./cart3.svg": "0IL2",
	"./cart4.svg": "5LVF",
	"./cash-stack.svg": "FiZM",
	"./cash.svg": "SV64",
	"./cast.svg": "q6av",
	"./chanpinku.svg": "JFoz",
	"./chat-dots-fill.svg": "d4aL",
	"./chat-dots.svg": "tG1u",
	"./chat-fill.svg": "mg+w",
	"./chat-left-dots-fill.svg": "mxr+",
	"./chat-left-dots.svg": "6vlh",
	"./chat-left-fill.svg": "O+Z1",
	"./chat-left-quote-fill.svg": "jGhH",
	"./chat-left-quote.svg": "o6Yy",
	"./chat-left-text-fill.svg": "6JvN",
	"./chat-left-text.svg": "6X+7",
	"./chat-left.svg": "8VC5",
	"./chat-quote-fill.svg": "5UIa",
	"./chat-quote.svg": "WlMk",
	"./chat-right-dots-fill.svg": "tjV4",
	"./chat-right-dots.svg": "wFDO",
	"./chat-right-fill.svg": "eD7M",
	"./chat-right-quote-fill.svg": "UX8R",
	"./chat-right-quote.svg": "dS37",
	"./chat-right-text-fill.svg": "rzVs",
	"./chat-right-text.svg": "S2xZ",
	"./chat-right.svg": "ZuRt",
	"./chat-square-dots-fill.svg": "TPJB",
	"./chat-square-dots.svg": "fmyz",
	"./chat-square-fill.svg": "uB2t",
	"./chat-square-quote-fill.svg": "aEXh",
	"./chat-square-quote.svg": "K2Ms",
	"./chat-square-text-fill.svg": "yYcX",
	"./chat-square-text.svg": "g05y",
	"./chat-square.svg": "nvoe",
	"./chat-text-fill.svg": "mHdM",
	"./chat-text.svg": "V6e/",
	"./chat.svg": "VxLz",
	"./check-all.svg": "1IZ7",
	"./check-circle-fill.svg": "rXuj",
	"./check-circle.svg": "qrlD",
	"./check-square-fill.svg": "huD6",
	"./check-square.svg": "Nb++",
	"./check.svg": "7ZS0",
	"./check2-all.svg": "fe9q",
	"./check2-circle.svg": "9OUE",
	"./check2-square.svg": "txMS",
	"./check2.svg": "Onbk",
	"./chevron-bar-contract.svg": "WIbj",
	"./chevron-bar-down.svg": "yB8F",
	"./chevron-bar-expand.svg": "VrGe",
	"./chevron-bar-left.svg": "Rpxy",
	"./chevron-bar-right.svg": "opAR",
	"./chevron-bar-up.svg": "8kBa",
	"./chevron-compact-down.svg": "xwXr",
	"./chevron-compact-left.svg": "PxxK",
	"./chevron-compact-right.svg": "Bv4U",
	"./chevron-compact-up.svg": "1yZZ",
	"./chevron-contract.svg": "tciH",
	"./chevron-double-down.svg": "TwWq",
	"./chevron-double-left.svg": "gCYF",
	"./chevron-double-right.svg": "Swo/",
	"./chevron-double-up.svg": "qeQZ",
	"./chevron-down.svg": "epVH",
	"./chevron-expand.svg": "TElb",
	"./chevron-left.svg": "mnEe",
	"./chevron-right.svg": "I1IY",
	"./chevron-up.svg": "OiT2",
	"./circle-fill.svg": "Jx4l",
	"./circle-half.svg": "+AYL",
	"./circle-square.svg": "YLrK",
	"./circle.svg": "5gjf",
	"./clipboard-check.svg": "zfSk",
	"./clipboard-data.svg": "6fp8",
	"./clipboard-minus.svg": "mPbV",
	"./clipboard-plus.svg": "SxBD",
	"./clipboard-x.svg": "UA/V",
	"./clipboard.svg": "KO/S",
	"./clock-fill.svg": "LN9R",
	"./clock-history.svg": "tV7G",
	"./clock.svg": "z5wF",
	"./cloud-arrow-down-fill.svg": "qcPM",
	"./cloud-arrow-down.svg": "zp+c",
	"./cloud-arrow-up-fill.svg": "qrpu",
	"./cloud-arrow-up.svg": "ES0w",
	"./cloud-check-fill.svg": "nhkb",
	"./cloud-check.svg": "qCLR",
	"./cloud-download-fill.svg": "tMxf",
	"./cloud-download.svg": "pgGC",
	"./cloud-fill.svg": "AIR0",
	"./cloud-minus-fill.svg": "Bi78",
	"./cloud-minus.svg": "Lu2Q",
	"./cloud-plus-fill.svg": "0U3O",
	"./cloud-plus.svg": "66bl",
	"./cloud-slash-fill.svg": "qfHR",
	"./cloud-slash.svg": "JvuV",
	"./cloud-upload-fill.svg": "dmgD",
	"./cloud-upload.svg": "pihZ",
	"./cloud.svg": "Yvcf",
	"./code-slash.svg": "eNuM",
	"./code-square.svg": "k+4X",
	"./code.svg": "IX5Q",
	"./collection-fill.svg": "kcSa",
	"./collection-play-fill.svg": "063N",
	"./collection-play.svg": "DNxU",
	"./collection.svg": "a4vn",
	"./columns-gap.svg": "5enh",
	"./columns.svg": "19nk",
	"./command.svg": "SM73",
	"./compass-fill.svg": "WTfc",
	"./compass.svg": "jlxC",
	"./cone-striped.svg": "zxpJ",
	"./cone.svg": "fCzR",
	"./congyezhe.svg": "RxA4",
	"./controller.svg": "1OyI",
	"./cpu-fill.svg": "5E8L",
	"./cpu.svg": "J/NN",
	"./credit-card-2-back-fill.svg": "sOIk",
	"./credit-card-2-back.svg": "NKjS",
	"./credit-card-2-front-fill.svg": "28K1",
	"./credit-card-2-front.svg": "4/1N",
	"./credit-card-fill.svg": "FuUv",
	"./credit-card.svg": "igCf",
	"./crop.svg": "3W0A",
	"./cup-fill.svg": "XDqC",
	"./cup-straw.svg": "QUIf",
	"./cup.svg": "+29O",
	"./cursor-fill.svg": "Gbdu",
	"./cursor-text.svg": "+5mG",
	"./cursor.svg": "kpwe",
	"./dash-circle-fill.svg": "9kux",
	"./dash-circle.svg": "fky/",
	"./dash-square-fill.svg": "jeUA",
	"./dash-square.svg": "+m9c",
	"./dash.svg": "1rIj",
	"./dashboard.svg": "BCGP",
	"./diagram-2-fill.svg": "kwZk",
	"./diagram-2.svg": "TRLw",
	"./diagram-3-fill.svg": "qJsf",
	"./diagram-3.svg": "SAly",
	"./diamond-fill.svg": "6T2B",
	"./diamond-half.svg": "GXF1",
	"./diamond.svg": "qpb/",
	"./dice-1-fill.svg": "W2pe",
	"./dice-1.svg": "UJvk",
	"./dice-2-fill.svg": "fOEE",
	"./dice-2.svg": "Ds/Z",
	"./dice-3-fill.svg": "skxM",
	"./dice-3.svg": "cQXG",
	"./dice-4-fill.svg": "ySN9",
	"./dice-4.svg": "Ypag",
	"./dice-5-fill.svg": "1a3V",
	"./dice-5.svg": "Pkzs",
	"./dice-6-fill.svg": "JolH",
	"./dice-6.svg": "ARHm",
	"./display-fill.svg": "7m+x",
	"./display.svg": "ebzu",
	"./distribute-horizontal.svg": "FUyz",
	"./distribute-vertical.svg": "tXbI",
	"./door-closed-fill.svg": "CYx8",
	"./door-closed.svg": "k2+i",
	"./door-open-fill.svg": "wmeB",
	"./door-open.svg": "pHmQ",
	"./dot.svg": "UmG+",
	"./download.svg": "+H2/",
	"./droplet-fill.svg": "wV5s",
	"./droplet-half.svg": "ln7g",
	"./droplet.svg": "lYqr",
	"./earbuds.svg": "zwKc",
	"./easel-fill.svg": "3RdE",
	"./easel.svg": "DtCq",
	"./egg-fill.svg": "VdNM",
	"./egg-fried.svg": "DwK3",
	"./egg.svg": "lqRe",
	"./eject-fill.svg": "aHZ0",
	"./eject.svg": "AK8S",
	"./emoji-angry-fill.svg": "bZDQ",
	"./emoji-angry.svg": "bBdD",
	"./emoji-dizzy-fill.svg": "vYDk",
	"./emoji-dizzy.svg": "naFE",
	"./emoji-expressionless-fill.svg": "nWXX",
	"./emoji-expressionless.svg": "nEUX",
	"./emoji-frown-fill.svg": "oyeq",
	"./emoji-frown.svg": "86kB",
	"./emoji-heart-eyes-fill.svg": "j7ob",
	"./emoji-heart-eyes.svg": "vAga",
	"./emoji-laughing-fill.svg": "a/Nt",
	"./emoji-laughing.svg": "Givf",
	"./emoji-neutral-fill.svg": "aHiT",
	"./emoji-neutral.svg": "iamo",
	"./emoji-smile-fill.svg": "aWCE",
	"./emoji-smile-upside-down-fill.svg": "qNod",
	"./emoji-smile-upside-down.svg": "UZ99",
	"./emoji-smile.svg": "Biq+",
	"./emoji-sunglasses-fill.svg": "4DXb",
	"./emoji-sunglasses.svg": "pnZG",
	"./emoji-wink-fill.svg": "5Mdi",
	"./emoji-wink.svg": "WlnC",
	"./envelope-fill.svg": "5knx",
	"./envelope-open-fill.svg": "k8Ci",
	"./envelope-open.svg": "6coN",
	"./envelope.svg": "mvem",
	"./example.svg": "OOLB",
	"./exclamation-circle-fill.svg": "Ropu",
	"./exclamation-circle.svg": "Jr9N",
	"./exclamation-diamond-fill.svg": "o0Xz",
	"./exclamation-diamond.svg": "eErs",
	"./exclamation-octagon-fill.svg": "QToI",
	"./exclamation-octagon.svg": "i/Hx",
	"./exclamation-square-fill.svg": "JbIp",
	"./exclamation-square.svg": "95uI",
	"./exclamation-triangle-fill.svg": "WESL",
	"./exclamation-triangle.svg": "eLyf",
	"./exclamation.svg": "hPuq",
	"./exclude.svg": "FeuW",
	"./exit.svg": "QQPv",
	"./eye-fill.svg": "ij7z",
	"./eye-open.svg": "no6o",
	"./eye-slash-fill.svg": "eQw0",
	"./eye-slash.svg": "iKpW",
	"./eye.svg": "4wdf",
	"./eye1.svg": "TFsh",
	"./eye2.svg": "LU0t",
	"./eyeglasses.svg": "Omb7",
	"./file-arrow-down-fill.svg": "Dp04",
	"./file-arrow-down.svg": "jRCa",
	"./file-arrow-up-fill.svg": "+Ud/",
	"./file-arrow-up.svg": "4S1S",
	"./file-bar-graph-fill.svg": "gqpv",
	"./file-bar-graph.svg": "pnxN",
	"./file-binary-fill.svg": "a4pF",
	"./file-binary.svg": "Ff0V",
	"./file-break-fill.svg": "q/Dz",
	"./file-break.svg": "SzdQ",
	"./file-check-fill.svg": "ya7A",
	"./file-check.svg": "KEzm",
	"./file-code-fill.svg": "p9Z+",
	"./file-code.svg": "XqKn",
	"./file-diff-fill.svg": "Hj8j",
	"./file-diff.svg": "QHF3",
	"./file-earmark-arrow-down-fill.svg": "44Gy",
	"./file-earmark-arrow-down.svg": "VlnO",
	"./file-earmark-arrow-up-fill.svg": "ZD1S",
	"./file-earmark-arrow-up.svg": "sIpg",
	"./file-earmark-bar-graph-fill.svg": "V/hl",
	"./file-earmark-bar-graph.svg": "6ocZ",
	"./file-earmark-binary-fill.svg": "OMDY",
	"./file-earmark-binary.svg": "erXp",
	"./file-earmark-break-fill.svg": "aDPw",
	"./file-earmark-break.svg": "tYiW",
	"./file-earmark-check-fill.svg": "uvNH",
	"./file-earmark-check.svg": "2P6G",
	"./file-earmark-code-fill.svg": "WO4Y",
	"./file-earmark-code.svg": "UaF+",
	"./file-earmark-diff-fill.svg": "le7D",
	"./file-earmark-diff.svg": "sK03",
	"./file-earmark-easel-fill.svg": "o8ba",
	"./file-earmark-easel.svg": "jeOm",
	"./file-earmark-excel-fill.svg": "jDi9",
	"./file-earmark-excel.svg": "O0W9",
	"./file-earmark-fill.svg": "fU20",
	"./file-earmark-font-fill.svg": "bOzR",
	"./file-earmark-font.svg": "e6ww",
	"./file-earmark-image-fill.svg": "9E6t",
	"./file-earmark-image.svg": "zUsn",
	"./file-earmark-lock-fill.svg": "H+f3",
	"./file-earmark-lock.svg": "w22f",
	"./file-earmark-lock2-fill.svg": "reXR",
	"./file-earmark-lock2.svg": "/1ep",
	"./file-earmark-medical-fill.svg": "Ixgw",
	"./file-earmark-medical.svg": "8DQ0",
	"./file-earmark-minus-fill.svg": "c0VG",
	"./file-earmark-minus.svg": "GIhV",
	"./file-earmark-music-fill.svg": "D70M",
	"./file-earmark-music.svg": "OC5i",
	"./file-earmark-person-fill.svg": "FiXH",
	"./file-earmark-person.svg": "xkhC",
	"./file-earmark-play-fill.svg": "xYHV",
	"./file-earmark-play.svg": "lB0L",
	"./file-earmark-plus-fill.svg": "GWuM",
	"./file-earmark-plus.svg": "SN1S",
	"./file-earmark-post-fill.svg": "RwtW",
	"./file-earmark-post.svg": "AGGO",
	"./file-earmark-ppt-fill.svg": "IZVb",
	"./file-earmark-ppt.svg": "e5gU",
	"./file-earmark-richtext-fill.svg": "TnGw",
	"./file-earmark-richtext.svg": "fpqY",
	"./file-earmark-ruled-fill.svg": "4qwH",
	"./file-earmark-ruled.svg": "nfjA",
	"./file-earmark-slides-fill.svg": "tmNO",
	"./file-earmark-slides.svg": "3Hy2",
	"./file-earmark-spreadsheet-fill.svg": "+Vqr",
	"./file-earmark-spreadsheet.svg": "CNVz",
	"./file-earmark-text-fill.svg": "YWk3",
	"./file-earmark-text.svg": "OL4M",
	"./file-earmark-word-fill.svg": "NyD+",
	"./file-earmark-word.svg": "PQjD",
	"./file-earmark-x-fill.svg": "1Em1",
	"./file-earmark-x.svg": "L1hs",
	"./file-earmark-zip-fill.svg": "emdE",
	"./file-earmark-zip.svg": "gkdZ",
	"./file-earmark.svg": "AiX6",
	"./file-easel-fill.svg": "z/8y",
	"./file-easel.svg": "tq1z",
	"./file-excel-fill.svg": "CLwL",
	"./file-excel.svg": "7OQh",
	"./file-fill.svg": "dwKn",
	"./file-font-fill.svg": "YQ8i",
	"./file-font.svg": "qfiq",
	"./file-image-fill.svg": "eV+W",
	"./file-image.svg": "VgOL",
	"./file-lock-fill.svg": "RSSp",
	"./file-lock.svg": "CsNo",
	"./file-lock2-fill.svg": "NJoZ",
	"./file-lock2.svg": "+t9T",
	"./file-medical-fill.svg": "koPF",
	"./file-medical.svg": "DHTz",
	"./file-minus-fill.svg": "XaSB",
	"./file-minus.svg": "D3D9",
	"./file-music-fill.svg": "f5uG",
	"./file-music.svg": "tRrV",
	"./file-person-fill.svg": "AGdl",
	"./file-person.svg": "kRCw",
	"./file-play-fill.svg": "vvIq",
	"./file-play.svg": "sqQq",
	"./file-plus-fill.svg": "poFs",
	"./file-plus.svg": "GEaK",
	"./file-post-fill.svg": "e7i8",
	"./file-post.svg": "kSeK",
	"./file-ppt-fill.svg": "scgV",
	"./file-ppt.svg": "BfPc",
	"./file-richtext-fill.svg": "ihzt",
	"./file-richtext.svg": "o8Aq",
	"./file-ruled-fill.svg": "xcYp",
	"./file-ruled.svg": "V3wv",
	"./file-slides-fill.svg": "fg6j",
	"./file-slides.svg": "NDis",
	"./file-spreadsheet-fill.svg": "BMYd",
	"./file-spreadsheet.svg": "AVoG",
	"./file-text-fill.svg": "78xJ",
	"./file-text.svg": "kCcm",
	"./file-word-fill.svg": "J2Y9",
	"./file-word.svg": "e8XR",
	"./file-x-fill.svg": "jcct",
	"./file-x.svg": "dEzb",
	"./file-zip-fill.svg": "7hJ/",
	"./file-zip.svg": "yu1U",
	"./file.svg": "fQ0v",
	"./files-alt.svg": "3W2M",
	"./files.svg": "KePA",
	"./film.svg": "z+U+",
	"./filter-circle-fill.svg": "P9D5",
	"./filter-circle.svg": "9Emj",
	"./filter-left.svg": "MpkR",
	"./filter-right.svg": "Ydt+",
	"./filter-square-fill.svg": "RvUc",
	"./filter-square.svg": "cYcK",
	"./filter.svg": "ObMl",
	"./flag-fill.svg": "fjXB",
	"./flag.svg": "meDM",
	"./flower1.svg": "Kd+h",
	"./flower2.svg": "IiQO",
	"./flower3.svg": "oeIs",
	"./folder-check.svg": "iNRf",
	"./folder-fill.svg": "vqeY",
	"./folder-minus.svg": "NTGw",
	"./folder-plus.svg": "ApE7",
	"./folder-symlink-fill.svg": "qXIg",
	"./folder-symlink.svg": "PRqu",
	"./folder-x.svg": "Nw0J",
	"./folder.svg": "XXSE",
	"./folder2-open.svg": "WoYk",
	"./folder2.svg": "JGeU",
	"./fonts.svg": "eR8v",
	"./form.svg": "sTIr",
	"./forward-fill.svg": "dg0q",
	"./forward.svg": "kuTh",
	"./front.svg": "X4Wa",
	"./fullscreen-exit.svg": "WrSm",
	"./fullscreen.svg": "WIff",
	"./funnel-fill.svg": "VgaY",
	"./funnel.svg": "q7mS",
	"./gear-fill.svg": "JdDa",
	"./gear-wide-connected.svg": "USLx",
	"./gear-wide.svg": "vrF3",
	"./gear.svg": "+4bU",
	"./gem.svg": "2gmE",
	"./geo-alt-fill.svg": "giEw",
	"./geo-alt.svg": "DwYj",
	"./geo-fill.svg": "K50H",
	"./geo.svg": "j2Hw",
	"./gift-fill.svg": "MtJA",
	"./gift.svg": "UndF",
	"./globe.svg": "TE0y",
	"./globe2.svg": "Wyl0",
	"./graph-down.svg": "MvoW",
	"./graph-up.svg": "E3YR",
	"./grid-1x2-fill.svg": "Vcu9",
	"./grid-1x2.svg": "FFlP",
	"./grid-3x2-gap-fill.svg": "8g7x",
	"./grid-3x2-gap.svg": "O5Wr",
	"./grid-3x2.svg": "OUc9",
	"./grid-3x3-gap-fill.svg": "4PXU",
	"./grid-3x3-gap.svg": "oZQb",
	"./grid-3x3.svg": "fxO5",
	"./grid-fill.svg": "b/lf",
	"./grid.svg": "MDBM",
	"./grip-horizontal.svg": "nCQq",
	"./grip-vertical.svg": "lom8",
	"./hammer.svg": "zjmq",
	"./hand-index-thumb.svg": "Pr5u",
	"./hand-index.svg": "4eJi",
	"./hand-thumbs-down.svg": "DESS",
	"./hand-thumbs-up.svg": "6zpW",
	"./handbag-fill.svg": "U5gs",
	"./handbag.svg": "AZjL",
	"./hash.svg": "kT93",
	"./hdd-fill.svg": "ezkN",
	"./hdd-network-fill.svg": "i+S9",
	"./hdd-network.svg": "mXVY",
	"./hdd-rack-fill.svg": "Y8Vy",
	"./hdd-rack.svg": "UmJg",
	"./hdd-stack-fill.svg": "kdrq",
	"./hdd-stack.svg": "Soox",
	"./hdd.svg": "o4MV",
	"./headphones.svg": "DdGi",
	"./headset.svg": "Q2fc",
	"./heart-fill.svg": "LlrI",
	"./heart-half.svg": "go22",
	"./heart.svg": "q9dO",
	"./heptagon-fill.svg": "Xhmv",
	"./heptagon-half.svg": "b6bg",
	"./heptagon.svg": "AFXR",
	"./hexagon-fill.svg": "Vf7Q",
	"./hexagon-half.svg": "3LIl",
	"./hexagon.svg": "CWYF",
	"./hourglass-bottom.svg": "nQJ4",
	"./hourglass-split.svg": "Wki1",
	"./hourglass-top.svg": "95xV",
	"./hourglass.svg": "K5WF",
	"./house-door-fill.svg": "oub9",
	"./house-door.svg": "Mf+m",
	"./house-fill.svg": "n/Qr",
	"./house.svg": "DUyu",
	"./hr.svg": "ih0B",
	"./huiyuan.svg": "kwqO",
	"./image-alt.svg": "Tzl6",
	"./image-fill.svg": "QWUU",
	"./image.svg": "dDyW",
	"./images.svg": "eU69",
	"./inbox-fill.svg": "GAam",
	"./inbox.svg": "ErHn",
	"./inboxes-fill.svg": "kK83",
	"./inboxes.svg": "/Kij",
	"./info-circle-fill.svg": "cZj/",
	"./info-circle.svg": "erNh",
	"./info-square-fill.svg": "QH/z",
	"./info-square.svg": "nQz2",
	"./info.svg": "Yfis",
	"./input-cursor-text.svg": "0Iji",
	"./input-cursor.svg": "26Hp",
	"./intersect.svg": "KrGW",
	"./journal-album.svg": "NGYM",
	"./journal-arrow-down.svg": "spi5",
	"./journal-arrow-up.svg": "4nqI",
	"./journal-bookmark-fill.svg": "/Nm2",
	"./journal-bookmark.svg": "dKce",
	"./journal-check.svg": "7a0k",
	"./journal-code.svg": "/hjI",
	"./journal-medical.svg": "QMOR",
	"./journal-minus.svg": "iT10",
	"./journal-plus.svg": "+h+k",
	"./journal-richtext.svg": "Zxfo",
	"./journal-text.svg": "ip0/",
	"./journal-x.svg": "4Fyu",
	"./journal.svg": "UVyV",
	"./journals.svg": "b5Kf",
	"./joystick.svg": "vi5T",
	"./justify-left.svg": "/1k6",
	"./justify-right.svg": "pcuZ",
	"./justify.svg": "W9Mi",
	"./kanban-fill.svg": "faVe",
	"./kanban.svg": "tlNx",
	"./key-fill.svg": "DwZG",
	"./key.svg": "rzEf",
	"./keyboard-fill.svg": "N0J3",
	"./keyboard.svg": "p8G8",
	"./ladder.svg": "yvuN",
	"./lamp-fill.svg": "BKOM",
	"./lamp.svg": "ks0v",
	"./laptop-fill.svg": "zvx7",
	"./laptop.svg": "UrMO",
	"./layers-fill.svg": "918d",
	"./layers-half.svg": "aVvW",
	"./layers.svg": "cWNl",
	"./layout-sidebar-inset-reverse.svg": "3pRx",
	"./layout-sidebar-inset.svg": "NlAx",
	"./layout-sidebar-reverse.svg": "BpDI",
	"./layout-sidebar.svg": "CZQX",
	"./layout-split.svg": "stfy",
	"./layout-text-sidebar-reverse.svg": "vOla",
	"./layout-text-sidebar.svg": "q183",
	"./layout-text-window-reverse.svg": "lbyA",
	"./layout-text-window.svg": "htie",
	"./layout-three-columns.svg": "NKZD",
	"./layout-wtf.svg": "zOUe",
	"./life-preserver.svg": "/GS7",
	"./lightning-fill.svg": "2xfx",
	"./lightning.svg": "kF2r",
	"./link-45deg.svg": "UX5x",
	"./link.svg": "KgwQ",
	"./list-check.svg": "WCoJ",
	"./list-nested.svg": "MZJX",
	"./list-ol.svg": "JUWE",
	"./list-stars.svg": "pCVA",
	"./list-task.svg": "phov",
	"./list-ul.svg": "LKnQ",
	"./list.svg": "vuHp",
	"./lock-fill.svg": "mOQI",
	"./lock.svg": "FnAU",
	"./mailbox.svg": "342b",
	"./mailbox2.svg": "DUqG",
	"./map-fill.svg": "OWzx",
	"./map.svg": "maBF",
	"./markdown-fill.svg": "6AT+",
	"./markdown.svg": "xL5x",
	"./menu-app-fill.svg": "8SGW",
	"./menu-app.svg": "mU0o",
	"./menu-arrow-white.svg": "lfma",
	"./menu-button-fill.svg": "qOFM",
	"./menu-button-wide-fill.svg": "Ciqq",
	"./menu-button-wide.svg": "jqfq",
	"./menu-button.svg": "l1It",
	"./menu-down.svg": "5qH0",
	"./menu-up.svg": "q8GG",
	"./mic-fill.svg": "bCD+",
	"./mic-mute-fill.svg": "/9K5",
	"./mic-mute.svg": "4hDE",
	"./mic.svg": "zbJ9",
	"./minecart-loaded.svg": "JVMN",
	"./minecart.svg": "7vx3",
	"./moon.svg": "Ux9W",
	"./mouse.svg": "t33C",
	"./mouse2.svg": "gfDU",
	"./mouse3.svg": "fTG0",
	"./music-note-beamed.svg": "v7vI",
	"./music-note-list.svg": "ZtHN",
	"./music-note.svg": "ls00",
	"./music-player-fill.svg": "m/w8",
	"./music-player.svg": "/FYW",
	"./nested.svg": "798r",
	"./newspaper.svg": "JMhJ",
	"./node-minus-fill.svg": "awW1",
	"./node-minus.svg": "r5cl",
	"./node-plus-fill.svg": "6aUq",
	"./node-plus.svg": "gCVD",
	"./nut-fill.svg": "qulY",
	"./nut.svg": "hJ/R",
	"./octagon-fill.svg": "GSd3",
	"./octagon-half.svg": "73qX",
	"./octagon.svg": "ekSd",
	"./option.svg": "Gkio",
	"./outlet.svg": "/Yxz",
	"./palette2.svg": "5Bbu",
	"./paperclip.svg": "9oBW",
	"./paragraph.svg": "TYH+",
	"./password.svg": "QjmH",
	"./patch-check-fll.svg": "Mbxo",
	"./patch-check.svg": "cW/A",
	"./patch-exclamation-fll.svg": "DVFf",
	"./patch-exclamation.svg": "GKya",
	"./patch-minus-fll.svg": "Jboy",
	"./patch-minus.svg": "7Xq3",
	"./patch-plus-fll.svg": "KN7o",
	"./patch-plus.svg": "JHxm",
	"./patch-question-fll.svg": "mxx0",
	"./patch-question.svg": "uhYC",
	"./pause-fill.svg": "CtjH",
	"./pause.svg": "mQwT",
	"./peace-fill.svg": "x+Pb",
	"./peace.svg": "65yS",
	"./pen-fill.svg": "z733",
	"./pen.svg": "+Kap",
	"./pencil-fill.svg": "KQ4E",
	"./pencil-square.svg": "UjWx",
	"./pencil.svg": "F0/G",
	"./pentagon-fill.svg": "5jJh",
	"./pentagon-half.svg": "+BWf",
	"./pentagon.svg": "eXNO",
	"./people-fill.svg": "+UiX",
	"./people.svg": "GPe0",
	"./percent.svg": "SA3L",
	"./person-badge-fill.svg": "7Rub",
	"./person-badge.svg": "Dgs/",
	"./person-bounding-box.svg": "qw/C",
	"./person-check-fill.svg": "ny42",
	"./person-check.svg": "czXR",
	"./person-circle.svg": "KZ+S",
	"./person-dash-fill.svg": "Ig0H",
	"./person-dash.svg": "gl+q",
	"./person-fill.svg": "VWDE",
	"./person-lines-fill.svg": "lCgj",
	"./person-plus-fill.svg": "yXZX",
	"./person-plus.svg": "xmUr",
	"./person-square.svg": "qhhG",
	"./person-x-fill.svg": "AGry",
	"./person-x.svg": "c3tr",
	"./person.svg": "iMuv",
	"./phone-fill.svg": "Gum8",
	"./phone-landscape-fill.svg": "R+mb",
	"./phone-landscape.svg": "88Pc",
	"./phone-vibrate.svg": "z7V0",
	"./phone.svg": "7pRf",
	"./pie-chart-fill.svg": "QUuF",
	"./pie-chart.svg": "lSig",
	"./pip-fill.svg": "r3Uo",
	"./pip.svg": "MtoH",
	"./play-fill.svg": "zsUp",
	"./play.svg": "ufmG",
	"./plug-fill.svg": "DFs2",
	"./plug.svg": "NrOE",
	"./plus-circle-fill.svg": "MMnR",
	"./plus-circle.svg": "9CRK",
	"./plus-square-fill.svg": "iYID",
	"./plus-square.svg": "nPut",
	"./plus.svg": "f+Cd",
	"./power.svg": "aUH0",
	"./printer-fill.svg": "knh2",
	"./printer.svg": "Jn9L",
	"./puzzle-fill.svg": "2/XT",
	"./puzzle.svg": "eJKY",
	"./qudao.svg": "HUpy",
	"./question-circle-fill.svg": "jSf4",
	"./question-circle.svg": "mS/Y",
	"./question-diamond-fill.svg": "0E49",
	"./question-diamond.svg": "6lAV",
	"./question-octagon-fill.svg": "VZ5Y",
	"./question-octagon.svg": "HxDy",
	"./question-square-fill.svg": "kt5q",
	"./question-square.svg": "A+8d",
	"./question.svg": "noTa",
	"./receipt-cutoff.svg": "CUNx",
	"./receipt.svg": "GQBi",
	"./reception-0.svg": "V39w",
	"./reception-1.svg": "s0pX",
	"./reception-2.svg": "bp3M",
	"./reception-3.svg": "8yvO",
	"./reception-4.svg": "4eQi",
	"./reply-all-fill.svg": "DsnR",
	"./reply-all.svg": "Ye6F",
	"./reply-fill.svg": "5Mex",
	"./reply.svg": "Fedy",
	"./rss-fill.svg": "iueX",
	"./rss.svg": "xNoq",
	"./scissors.svg": "Fdkz",
	"./screwdriver.svg": "E4n4",
	"./search.svg": "Bx0U",
	"./segmented-nav.svg": "quaP",
	"./server.svg": "2Sb8",
	"./share-fill.svg": "SJH7",
	"./share.svg": "BDVe",
	"./shield-check.svg": "tH43",
	"./shield-exclamation.svg": "InXB",
	"./shield-fill-check.svg": "9sZs",
	"./shield-fill-exclamation.svg": "KwSi",
	"./shield-fill-minus.svg": "guIs",
	"./shield-fill-plus.svg": "eGNS",
	"./shield-fill-x.svg": "cVAs",
	"./shield-fill.svg": "4A6w",
	"./shield-lock-fill.svg": "hqP0",
	"./shield-lock.svg": "Mth3",
	"./shield-minus.svg": "kSu0",
	"./shield-plus.svg": "6fmG",
	"./shield-shaded.svg": "RByG",
	"./shield-slash-fill.svg": "X/aW",
	"./shield-slash.svg": "JDxe",
	"./shield-x.svg": "AqzC",
	"./shield.svg": "/n+E",
	"./shift-fill.svg": "PG3q",
	"./shift.svg": "92S4",
	"./shop-window.svg": "tKJP",
	"./shop.svg": "hert",
	"./shuffle.svg": "eT0M",
	"./signpost-2-fill.svg": "Uo+W",
	"./signpost-2.svg": "5oZH",
	"./signpost-fill.svg": "FAxV",
	"./signpost-split-fill.svg": "+vGW",
	"./signpost-split.svg": "LDeX",
	"./signpost.svg": "6ZrY",
	"./sim-fill.svg": "ohyF",
	"./sim.svg": "Mz8m",
	"./skip-backward-fill.svg": "Hofl",
	"./skip-backward.svg": "cdzu",
	"./skip-end-fill.svg": "lXlz",
	"./skip-end.svg": "vPdr",
	"./skip-forward-fill.svg": "Pc+k",
	"./skip-forward.svg": "Ro89",
	"./skip-start-fill.svg": "1bpS",
	"./skip-start.svg": "O08R",
	"./slack.svg": "Pyre",
	"./slash-circle-fill.svg": "JLa5",
	"./slash-circle.svg": "ww49",
	"./slash-square-fill.svg": "hmP4",
	"./slash-square.svg": "DQgC",
	"./slash.svg": "Dscl",
	"./sliders.svg": "lAct",
	"./smartwatch.svg": "m7Lp",
	"./sort-alpha-down-alt.svg": "2oNL",
	"./sort-alpha-down.svg": "77nk",
	"./sort-alpha-up-alt.svg": "ovkS",
	"./sort-alpha-up.svg": "sskt",
	"./sort-down-alt.svg": "pc4W",
	"./sort-down.svg": "PeLx",
	"./sort-numeric-down-alt.svg": "/i3G",
	"./sort-numeric-down.svg": "gH8k",
	"./sort-numeric-up-alt.svg": "8Th3",
	"./sort-numeric-up.svg": "U9Td",
	"./sort-up-alt.svg": "WbNv",
	"./sort-up.svg": "1y5K",
	"./soundwave.svg": "IB1s",
	"./speaker-fill.svg": "aus1",
	"./speaker.svg": "pNla",
	"./spellcheck.svg": "MZPI",
	"./square-fill.svg": "NV7g",
	"./square-half.svg": "j0Gf",
	"./square.svg": "rx/K",
	"./star-fill.svg": "MDvG",
	"./star-half.svg": "d2eA",
	"./star.svg": "60zo",
	"./stickies-fill.svg": "g3hv",
	"./stickies.svg": "4Y+x",
	"./sticky-fill.svg": "TZke",
	"./sticky.svg": "HlKT",
	"./stop-fill.svg": "QSgO",
	"./stop.svg": "Zyir",
	"./stoplights-fill.svg": "/j2c",
	"./stoplights.svg": "qyBJ",
	"./stopwatch-fill.svg": "ytYN",
	"./stopwatch.svg": "A2Pe",
	"./subtract.svg": "20AQ",
	"./suit-club-fill.svg": "uTr2",
	"./suit-club.svg": "olCA",
	"./suit-diamond-fill.svg": "vcLS",
	"./suit-diamond.svg": "C4VO",
	"./suit-heart-fill.svg": "gLT2",
	"./suit-heart.svg": "01dC",
	"./suit-spade-fill.svg": "OFRn",
	"./suit-spade.svg": "xF4o",
	"./sun.svg": "ZJ0R",
	"./sunglasses.svg": "mbg7",
	"./table.svg": "oSYw",
	"./tablet-fill.svg": "p4bl",
	"./tablet-landscape-fill.svg": "/Bq3",
	"./tablet-landscape.svg": "cXHF",
	"./tablet.svg": "E5Yw",
	"./tag-fill.svg": "PY+1",
	"./tag.svg": "0dAG",
	"./tags-fill.svg": "NbEK",
	"./tags.svg": "vNLF",
	"./telephone-fill.svg": "4qc+",
	"./telephone-forward-fill.svg": "tM2L",
	"./telephone-forward.svg": "FxBc",
	"./telephone-inbound-fill.svg": "tfMY",
	"./telephone-inbound.svg": "K549",
	"./telephone-minus-fill.svg": "Gumj",
	"./telephone-minus.svg": "wPu3",
	"./telephone-outbound-fill.svg": "BSrA",
	"./telephone-outbound.svg": "+s+Y",
	"./telephone-plus-fill.svg": "J+ae",
	"./telephone-plus.svg": "UwgT",
	"./telephone-x-fill.svg": "38ZK",
	"./telephone-x.svg": "pxc4",
	"./telephone.svg": "kk8Y",
	"./terminal-fill.svg": "21cF",
	"./terminal.svg": "gEzl",
	"./text-center.svg": "WLgT",
	"./text-indent-left.svg": "z+6s",
	"./text-indent-right.svg": "f8e2",
	"./text-left.svg": "vYRT",
	"./text-paragraph.svg": "fsjb",
	"./text-right.svg": "xQl4",
	"./textarea-resize.svg": "JqY4",
	"./textarea-t.svg": "LT9k",
	"./textarea.svg": "zlq4",
	"./thermometer-half.svg": "nT6o",
	"./thermometer.svg": "tuzZ",
	"./three-dots-vertical.svg": "am5F",
	"./three-dots.svg": "hFEG",
	"./toggle-off.svg": "zUII",
	"./toggle-on.svg": "gVZd",
	"./toggle2-off.svg": "tgDK",
	"./toggle2-on.svg": "O5di",
	"./toggles.svg": "UeBB",
	"./toggles2.svg": "FZX0",
	"./tools.svg": "a3rm",
	"./trash-fill.svg": "zTSw",
	"./trash.svg": "9CsS",
	"./trash2-fill.svg": "6zvI",
	"./trash2.svg": "1WBZ",
	"./tree-fill.svg": "Bwtq",
	"./tree.svg": "3eCm",
	"./triangle-fill.svg": "Y03V",
	"./triangle-half.svg": "1nSw",
	"./triangle.svg": "n/kJ",
	"./trophy-fill.svg": "9E1F",
	"./trophy.svg": "ILif",
	"./truck-flatbed.svg": "xHSw",
	"./truck.svg": "3Kjf",
	"./tv-fill.svg": "U8EO",
	"./tv.svg": "zEBP",
	"./type-bold.svg": "mCJ4",
	"./type-h1.svg": "WtxG",
	"./type-h2.svg": "8Fzd",
	"./type-h3.svg": "g5Sd",
	"./type-italic.svg": "90dy",
	"./type-strikethrough.svg": "MOHJ",
	"./type-underline.svg": "bvyu",
	"./type.svg": "Kg5v",
	"./ui-checks-grid.svg": "ocd0",
	"./ui-checks.svg": "gDP0",
	"./ui-radios-grid.svg": "E2jC",
	"./ui-radios.svg": "TdI4",
	"./union.svg": "eTfr",
	"./unlock-fill.svg": "hX17",
	"./unlock.svg": "JNNJ",
	"./upc-scan.svg": "aid7",
	"./upc.svg": "f8di",
	"./upload.svg": "P/TB",
	"./user.svg": "VdD3",
	"./vector-pen.svg": "uCOg",
	"./view-list.svg": "M6eh",
	"./view-stacked.svg": "DDWf",
	"./voicemail.svg": "DZye",
	"./volume-down-fill.svg": "QH8A",
	"./volume-down.svg": "8h8P",
	"./volume-mute-fill.svg": "HA2e",
	"./volume-mute.svg": "Q4cd",
	"./volume-off-fill.svg": "chHh",
	"./volume-off.svg": "aUAG",
	"./volume-up-fill.svg": "xNzn",
	"./volume-up.svg": "kb4o",
	"./vr.svg": "H4es",
	"./wallet-fill.svg": "YpFK",
	"./wallet.svg": "LnY7",
	"./wallet2.svg": "bWYq",
	"./watch.svg": "iQ4+",
	"./wifi-1.svg": "DqyQ",
	"./wifi-2.svg": "GS/i",
	"./wifi-off.svg": "voeK",
	"./wifi.svg": "cNBo",
	"./window.svg": "JhsZ",
	"./wrench.svg": "M1TT",
	"./x-circle-fill.svg": "V5Kz",
	"./x-circle.svg": "qXEe",
	"./x-diamond-fill.svg": "sV64",
	"./x-diamond.svg": "dNJz",
	"./x-octagon-fill.svg": "e/V2",
	"./x-octagon.svg": "Ktog",
	"./x-square-fill.svg": "zBSH",
	"./x-square.svg": "t/Yv",
	"./x.svg": "abAw",
	"./zoom-in.svg": "oTUC",
	"./zoom-out.svg": "WHXP",
	"./zuzhijiagou.svg": "Kf3M"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 60